import { Controller } from '@hotwired/stimulus';

export default class RevealFieldController extends Controller {
    static targets = [
        'bankName', 'accountHolder', 'accountNumber', 'swiftBic',
        'cardNumber', 'cardExpiry', 'cardCvv', 'cardHolder',
        'icon', 'label',
    ];
    static values = { url: String };

    declare readonly urlValue: string;
    declare readonly iconTarget: HTMLElement;
    declare readonly labelTarget: HTMLElement;

    private revealedData: Record<string, string> | null = null;
    private revealed = false;

    async toggle(): Promise<void> {
        if (this.revealed) {
            this.hide();
            return;
        }

        if (!this.revealedData) {
            try {
                const res = await fetch(this.urlValue, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
                this.revealedData = await res.json();
            } catch {
                return;
            }
        }

        this.show();
    }

    private setTargets(name: string, value: string): void {
        const targets = (this as any)[`${name}Targets`] as HTMLElement[] | undefined;
        if (targets) targets.forEach(el => el.textContent = value || '—');
    }

    private show(): void {
        if (!this.revealedData) return;
        const d = this.revealedData;
        this.setTargets('bankName',      d.bankName      ?? '');
        this.setTargets('accountHolder', d.accountHolder ?? '');
        this.setTargets('accountNumber', d.accountNumber ?? '');
        this.setTargets('swiftBic',      d.swiftBic      ?? '');
        this.setTargets('cardNumber',    d.cardNumber    ?? '');
        this.setTargets('cardExpiry',    d.cardExpiry    ?? '');
        this.setTargets('cardCvv',       d.cardCvv       ?? '');
        this.setTargets('cardHolder',    d.cardHolder    ?? '');

        this.iconTarget.className    = 'bi bi-eye-slash me-1';
        this.labelTarget.textContent = 'Ocultar';
        this.revealed = true;
    }

    private hide(): void {
        this.setTargets('bankName',      '••••••••');
        this.setTargets('accountHolder', '••••••••');
        this.setTargets('accountNumber', '••••••••');
        this.setTargets('swiftBic',      '••••••••');
        this.setTargets('cardNumber',    '•••• •••• •••• ••••');
        this.setTargets('cardExpiry',    '••/••');
        this.setTargets('cardCvv',       '•••');
        this.setTargets('cardHolder',    '••••••••');

        this.iconTarget.className    = 'bi bi-eye me-1';
        this.labelTarget.textContent = 'Mostrar';
        this.revealed = false;
    }
}
